
const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <h1 className="text-2xl font-bold text-pink-600" style={{ fontFamily: '"Pacifico", serif' }}>
            マイペットハウス
          </h1>
        </div>
      </header>

      {/* Privacy Policy Content */}
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-8">個人情報の取り扱いについて</h1>
          
          <div className="space-y-6 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-3">1. 個人情報の収集について</h2>
              <p>
                湯沢開発株式会社（以下「当社」）は、お客様からお預かりする個人情報を以下の目的で収集いたします：
              </p>
              <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                <li>モデルハウス見学のご案内</li>
                <li>お客様からのお問い合わせへの回答</li>
                <li>当社サービスに関する情報提供</li>
                <li>アフターサービスのご提供</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-3">2. 個人情報の利用目的</h2>
              <p>
                収集した個人情報は、以下の目的でのみ利用いたします：
              </p>
              <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                <li>お客様への連絡・情報提供</li>
                <li>見学予約の確認・調整</li>
                <li>商品・サービスのご提案</li>
                <li>統計資料の作成（個人を特定できない形式）</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-3">3. 個人情報の第三者提供</h2>
              <p>
                当社は、以下の場合を除き、お客様の個人情報を第三者に提供することはありません：
              </p>
              <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                <li>お客様の同意がある場合</li>
                <li>法令に基づく場合</li>
                <li>人の生命、身体または財産の保護のために必要がある場合</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-3">4. 個人情報の管理</h2>
              <p>
                当社は、お客様の個人情報を適切に管理し、紛失、破壊、改ざん、漏洩などを防止するため、必要かつ適切な安全管理措置を講じます。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-3">5. 個人情報の開示・訂正・削除</h2>
              <p>
                お客様は、当社が保有するご自身の個人情報について、開示、訂正、削除を求めることができます。
                ご希望の場合は、下記連絡先までお問い合わせください。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-3">6. お問い合わせ先</h2>
              <div className="bg-pink-50 p-4 rounded-lg">
                <p className="font-medium">湯沢開発株式会社</p>
                <p>〒012-0844 秋田県湯沢市田町２丁目１番３号</p>
                <p>TEL: 0183-56-7141</p>
                <p>営業時間: 8:45～17:00（水曜日定休）</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-3">7. プライバシーポリシーの変更</h2>
              <p>
                当社は、法令の変更等に伴い、本プライバシーポリシーを変更することがあります。
                変更後のプライバシーポリシーは、当ウェブサイトに掲載した時点から効力を生じるものとします。
              </p>
            </section>

            <div className="mt-8 text-right text-sm text-gray-500">
              制定日：2025年1月1日
            </div>
          </div>

          <div className="mt-8 text-center">
            <button 
              onClick={() => window.history.back()}
              className="bg-pink-500 text-white px-6 py-2 rounded-full hover:bg-pink-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              戻る
            </button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-gray-400 text-sm">
            Copyright© 2025 湯沢開発株式会社 All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
